import React, { useContext } from 'react';
import { AuthContext } from '../authProvider.mjs';

/**
 * Full-screen block shown when the signed-in account has been suspended.
 *
 * The backend rejects a suspended user's requests with ACCOUNT_SUSPENDED, but
 * without this they'd just see a scattering of failed calls and an app that
 * appears broken. This states plainly what happened and who to contact, and
 * covers the UI so the system can't be used.
 */
const SuspendedBanner = () => {
  const { isSuspended } = useContext(AuthContext);

  if (!isSuspended) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-gray-900/70 backdrop-blur-sm flex items-center justify-center px-4"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="suspended-title"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="bg-stanford-red text-white px-6 py-4">
          <h2 id="suspended-title" className="text-lg font-bold tracking-wide">
            ACCOUNT SUSPENDED
          </h2>
        </div>
        <div className="p-6">
          <p className="text-gray-800 mb-3">
            Your account has been suspended, so you can no longer access the
            expense claim system.
          </p>
          <p className="text-gray-600 text-sm mb-6">
            Please <span className="font-semibold">contact your administrator</span> if
            you believe this is a mistake or need access restored.
          </p>
          <a
            href="/login"
            className="inline-block px-5 py-2.5 bg-stanford-red text-white rounded-lg hover:bg-stanford-light-red transition-colors"
          >
            Return to sign in
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuspendedBanner;
